import React, { useEffect, useMemo, useState } from "react";
import useProgramDetail from "../../../hooks/useProgramDetail";
import $ from "jquery";
import JsPDF from "jspdf";
import Papa from "papaparse";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import CareerPicker from "../../careerLibrary/CareerPicker";
import SkeletonLoaderBasic from "../../../loaders/SkeletonLoaderBasic";
import {
  GetListProgrammeAndShortCourse,
  GetPagesList,
} from "../../../services/ProgramService";
import {
  RenderProgrammeOrCourseType,
  RenderProgrammeType,
} from "../../../utils/CommonGroupingItem";
import {
  RenderPMCPageStatus,
  RenderPMCStatus,
  RenderPMCStatusCol
} from "../../../utils/CommonStatusItems";
import DataTableComponent from "../../common/DataTableComponent";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import { TrimText } from "../../common/TrimText";
import { TermPeriods } from "../../systemadministration/DataReactSelect";
import StickyFooter from "../../library/StickyFooter";
import Modal from "../../library/Modal";
import ProgrammeSummaryStrip from "../../library/ProgrammeSummaryStrip";
import TextInput from "../../library/TextInput";
import SelectDropdown from "../../library/SelectDropdown";
import MultiSelectDropdown from "../../library/MultiSelectDropdown";
import ToggleSwitch from "../../library/ToggleSwitch";
import Checkbox from "../../library/Checkbox";
import Button from "../../common/Button/Button";
import PermissionsGate from "../../../utils/permissionGate";
import { mapBuildingsToSelect } from "../../../utils/CampusBuildingsUtil";
import { mapOptions, resolveVersionSummaryState } from "../../../utils/ProgramDetailUtils";
import {
  ProgrammeContentWrapper,
  PageSections,
  UnsavedChangesText,
  ProgrammeSection,
  ProgrammeSectionHeader,
  ProgrammeSectionTitle,
  ProgrammeSectionBody,
  ProgrammeInformationGrid,
  ProgrammeField,
  IntegrationStack,
  ReRegistrationFrequencyField,
  ReRegistrationCountField,
  ReRegistrationGrid,
  SectionLoadingIcon,
  AccordionWrapper,
  AccordionSection,
  AccordionCard,
  AccordionCardHeader,
  AccordionButton,
  AccordionTitle,
  AccordionChevronIcon,
  AccordionContent,
  AccordionBody,
  AccordionStack,
  CheckboxRow,
} from "./ProgramDetail.styles";

const reRegFrequencyOptions = [
  { value: 0, label: "Semester Based" },
  { value: 1, label: "Annual" }
];

const statusArr = [
  { value: "Draft", label: "Draft" },
  { value: "New", label: "New" },
  { value: "Final", label: "Final" },
  { value: "Approved", label: "Approved" },
  { value: "Inactive", label: "Inactive" }
];

const NQF_LevelArr = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
];

//TODO: This should be DB driven in future.
const minAdmissionLevelOptions = [
  { value: "none", label: "None" },
  { value: "grade11", label: "Grade 11" },
  { value: "matric", label: "Matric" },
  { value: "certificate", label: "National Certificate" },
  { value: "diploma", label: "Diploma" },
  { value: "degree", label: "Bachelor’s Degree" },
  { value: "honours", label: "Honours Degree" },
];

/**
 * PMC Programme detail/edit form: displays and edits a programme's fields.
 * @param {object} detail The programme detail record being edited.
 * @param {Function} setRefresh Triggers a re-fetch of the programme detail.
 * @param {Function} setQAview Toggles the QA/versioned view.
 */
function ProgramDetail({ detail, setRefresh, setQAview }) {
  const {
    history,
    id,
    type,
    disabled,
    showCancelConfirmation,
    setShowCancelConfirmation,
    subjectContent,
    setSubjectContent,
    admissionReq,
    setAdmissionReq,
    accreditation,
    setAccreditation,
    articulationOption,
    setArticulationOption,
    studyKit,
    setStudyKit,
    careerOpportunity,
    setCareerOpportunity,
    hardwareReq,
    setHardwareReq,
    duration,
    setDuration,
    regulatoryInfo,
    setRegulatoryInfo,
    impNotes,
    setImpNotes,
    editorToShow,
    schoolList,
    netsuiteProdList,
    activeVersionList,
    versionList,
    versionListLoading,
    summaryTotals,
    summaryTotalsLoading,
    allpageListData,
    setAllPageListData,
    assignPageList,
    assignPageLoading,
    pageStatus,
    setPageStatus,
    pageBrand,
    setPageBrand,
    loading,
    PageFilterData,
    assignPageTableState,
    setAssignPageTableState,
    assignPageSearch,
    setAssignPageSearch,
    assignPageTotalRows,
    articulationOptionList,
    articulationOptionLoading,
    articulationOptionSearch,
    setArticulationOptionSearch,
    articulationOptionTotalRow,
    articulationOptionTableState,
    setArticulationOptionTableState,
    artStatus,
    setArtStatus,
    artProgType,
    setArtProgType,
    articulationOptionFilterData,
    artType,
    setArtType,
    assignedArticulationOptionList,
    setAssignedArticulationOptionList,
    assignedArticulationSearch,
    setAssignedArticulationSearch,
    assignedStatus,
    setAssignedStatus,
    assignedProgType,
    setAssignedProgType,
    assignedType,
    setAssignedType,
    assignedArticulationOptionFilterData,
    dropDownValues,
    campusBuildingsList,
    formik,
    handleChangeInstallments,
    hasUnsavedChanges,
    restoreSavedValues,
    handlereset,
    markRichContentTouched,
  } = useProgramDetail({
    detail,
    setRefresh,
    setQAview,
  });

  // Accordion-style single-open section: only one editorArr item's content shows at a time.
  const [openAccordionId, setOpenAccordionId] = useState(null);

  const assignPageColumn = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortField: "PageTitle",
      cell: (row) => (
        <span
          className="as-text-blue curser feature-name"
          onClick={() => {
            formik.setFieldValue("terms_conditions_page", row.PageID);
            $("#assignPagePopup").modal("hide");
          }}
          title={row.title}
        >
          <span className="textLimit100">
            {row.PageTitle ? row.PageTitle : "-"}
          </span>
        </span>
      ),
    },
    {
      name: "Status",
      selector: "Status",
      sortField: "status",
      sortable: true,
      cell: (row) => (row.status ? RenderPMCStatusCol(row.status).html : "-"),
    },
    {
      name: "Brand Templates",
      selector: "Brand Templates",
      sortable: false,
      cell: (row) => (
        <div>
          <div className="d-flex flex-wrap">
            {row?.brandTemplete?.length > 0
              ? row?.brandTemplete.map(
                (brand, index) =>
                  brand?.templateName && (
                    <div key={row.title + "_" + index} className="brandList-pmc" title={brand?.templateName}>
                      {brand?.templateName}
                    </div>
                  )
              )
              : "-"}
          </div>
        </div>
      ),
    },
    {
      name: "Action",
      selector: "",
      maxWidth: "50px",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            {formik.values.terms_conditions_page != row?.PageID ? (
              <button
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => {
                  formik.setFieldValue("terms_conditions_page", row?.PageID);
                  formik.setFieldValue("terms_conditions_page_type", row?.PageTitle);
                  $("#assignPagePopup").modal("hide");
                }}
                title="Assign Page"
              >
                <i className="fal fa-plus"></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger rounded-circle"
                onClick={() => {
                  formik.setFieldValue("terms_conditions_page", "");
                  formik.setFieldValue("terms_conditions_page_type", "");
                }}
                title="Assign Page"
              >
                <i className="fal fa-minus"></i>
              </button>
            )}
          </div>
        </div>
      ),
    },
  ]);

  const dataToRender = () => {
    let updatedData = [];
    let allData = [...assignedArticulationOptionList];

    if (assignedArticulationSearch.length) {
      let name = allData.filter((item) => {
        let includes = item.name
          ?.toString()
          ?.toLowerCase()
          ?.includes(assignedArticulationSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...name];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (assignedStatus.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = assignedStatus.arr.find(function (post, index) {
          if (item.status && post.toLowerCase() === item.status.toLowerCase() ? item.status : "") { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedProgType.arr.length) {
      let tempProgType = updatedData;
      let tempResult = tempProgType.filter((item) => {
        const startsWith = assignedProgType.arr.find(function (post, index) {
          if (item.qualification_type && post === item.qualification_type ? item.qualification_type : "") { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = assignedType.arr.find(function (post, index) {
          if (item?.pmc_type?.toString() && post === (item?.pmc_type?.toString() ? item?.pmc_type?.toString() : "")) { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedArticulationSearch.length || assignedStatus.arr.length || assignedProgType.arr.length || assignedType.arr.length) {
      const uniqueData = updatedData.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id == value.id && t?.pmc_type == value?.pmc_type && t?.type == value?.type
        ))
      );
      return uniqueData;
    } else {
      const uniqueData = allData.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id == value.id && t?.pmc_type == value?.pmc_type && t?.type == value?.type
        ))
      );
      return uniqueData;
    }
  };

  const dataToRenderArticulationAssign = () => {
    let updatedData = [];
    let allData = assignedArticulationOptionList;
    if (assignedArticulationSearch.length) {
      let name = allData.filter((item) => {
        let includes = item.name.toString().toLowerCase().includes(assignedArticulationSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...name];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }
    if (assignedStatus.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = assignedStatus.arr.find(function (post, index) {
          if (item.status && post.toLowerCase() === item.status.toLowerCase() ? item.status : "") { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (assignedProgType.arr.length) {
      let tempProgType = updatedData;
      let tempResult = tempProgType.filter((item) => {
        const startsWith = assignedProgType.arr.find(function (post, index) {
          if (item.qualification_type && post === item.qualification_type ? item.qualification_type : "") { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }
    if (assignedType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = assignedType.arr.find(function (post, index) {
          if (item.type && post === item.type ? item.type : "") { return item; }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedStatus.arr.length || assignedProgType.arr.length || assignedType.arr.length || articulationOptionSearch.length) {
      return updatedData;
    } else {
      return allData;
    }
  };

  const exportDataAssignedArticulationOption = () => {
    let data = dataToRender();
    const header = ["Name", "Code", "Status", "Programme Type", "Type"];
    data = data.map((row) => ({
      Name: row?.name ? row?.name : "-",
      Code: row.Code ? row.Code : "-",
      Status: row.status ? row.status : "-",
      "Programme Type": row.qualification_type ? RenderProgrammeType(row?.qualification_type).text : "-",
      Type: row?.pmc_type !== null && row?.pmc_type !== undefined
        ? RenderProgrammeOrCourseType(row.pmc_type).text
        : row?.type !== null && row?.type !== undefined
          ? RenderProgrammeOrCourseType(row.type).text
          : "-",
    }));
    const pdfData = data.map((row) => {
      return [
        row["Name"],
        row["Code"],
        row["Status"],
        row["Programme Type"],
        row["Type"],
      ];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {},
    };
  };

  const exportDataArticulationOption = (fileType, fileName) => {
    let exportData = [...articulationOptionList];
    const header = ["Name", "Code", "Status", "Programme Type", "Type"];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    const payload = {
      page: articulationOptionTableState.page,
      limit: articulationOptionTableState.perPage,
      key: articulationOptionTableState.sortKey,
      sort: articulationOptionTableState.sortOrder,
      exportStatus: true,
      search: articulationOptionSearch,
      viaStatus: artStatus.arr,
      viaType: artType.arr,
      viaProgrammeType: artProgType.arr,
      id: id,
    };

    GetListProgrammeAndShortCourse(payload)
      .then((res) => {
        exportData = res.data.data?.resData;
        exportData = exportData?.map((row) => ({
          ...row,
          Name: row?.name ? row?.name : "-",
          Code: row.Code ? row.Code : "-",
          Status: row.status ? row.status : "-",
          "Programme Type": row.qualification_type ? RenderProgrammeType(row?.qualification_type).text : "-",
          Type: row?.pmc_type !== null && row?.pmc_type !== undefined
            ? RenderProgrammeOrCourseType(row.pmc_type).html
            : row?.type !== null && row?.type !== undefined
              ? RenderProgrammeOrCourseType(row.type).text
              : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, exportData });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = exportData.map((row) => {
            const obj = {};
            header.forEach((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = exportData.map((row) => {
            return [
              row["Name"],
              row["Code"],
              row["Status"],
              row["Programme Type"],
              row["Type"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const articulationOptionColumn = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortField: "name",
      cell: (row) => (
        <span className="as-text-blue curser feature-name" title={row.name}>
          <span className="textLimit100">{row.name ? row.name : "-"}</span>
        </span>
      ),
    },
    {
      name: "Code",
      selector: "code",
      sortable: true,
      sortField: "code",
      cell: (row) => (row.Code ? row.Code : "-"),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      sortField: "status",
      cell: (row) => row.status != null ? RenderPMCStatus(row.status).html : "-",
    },
    {
      name: "Programme Type",
      selector: "qualification_type",
      sortable: true,
      sortField: "qualification_type",
      cell: (row) => row.qualification_type != null ? RenderProgrammeType(row.qualification_type).html : "-",
    },
    {
      name: "Type",
      selector: "type",
      sortable: true,
      sortField: "type",
      cell: (row) => row.type != null ? RenderProgrammeOrCourseType(row.type).html : "-",
    },
    {
      name: "Action",
      selector: "",
      maxWidth: "50px",
      cell: (row) => {
        const isAssigned = assignedArticulationOptionList.some(
          (item) => item.id === row.id && (item.type || item.pmc_type) == (row.type || row.pmc_type)
        );
        const handleAssign = () => {
          setAssignedArticulationOptionList((prevList) => {
            const updatedList = isAssigned
              ? prevList.filter(
                (item) => !(item.id === row.id && (item.type || item.pmc_type) == (row.type || row.pmc_type))
              )
              : [...prevList, { ...row, isAssigned: true }];

            const assignedData = updatedList.map(({ id, type, pmc_type }) => ({
              id,
              pmc_type: type || pmc_type,
            }));

            formik.setFieldValue("articulation_assign", assignedData);
            return updatedList;
          });
        };

        return (
          <div className="assessment-08">
            <div className="as-buttons">
              <button
                type="button"
                className={`btn rounded-circle ${isAssigned ? "btn-danger" : "btn-primary"}`}
                onClick={handleAssign}
                title={isAssigned ? "Unassign Page" : "Assign Page"}
              >
                <i className={`fal fa-${isAssigned ? "minus" : "plus"}`}></i>
              </button>
            </div>
          </div>
        );
      },
    },
  ]);

  const sortingName = (rowA, rowB) => {
    const name1 = rowA.name ? rowA.name.toString() : "";
    const name2 = rowB.name ? rowB.name.toString() : "";
    return name1.localeCompare(name2);
  };

  const sortingCode = (rowA, rowB) => {
    const code1 = rowA.Code ? rowA.Code.toString() : "";
    const code2 = rowB.Code ? rowB.Code.toString() : "";
    return code1.localeCompare(code2);
  };

  const sortingProgrammeType = (rowA, rowB) => {
    const qualification_name1 = rowA.qualification_name ? rowA.qualification_name.toString() : "";
    const qualification_name2 = rowB.qualification_name ? rowB.qualification_name.toString() : "";
    return qualification_name1.localeCompare(qualification_name2);
  };

  const sortingType = (rowA, rowB) => {
    const type1 = rowA?.pmc_type || rowA?.type ? rowA?.type?.toString() || rowA?.pmc_type?.toString() : "";
    const type2 = rowB?.pmc_type || rowB?.type ? rowB?.type?.toString() || rowB?.pmc_type?.toString() : "";
    return type1.localeCompare(type2);
  };

  const ArticulationAssigncolumns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortFunction: sortingName,
      sortField: "name",
      sortable: true,
      cell: (row) => (
        <Link
          to={`/program-management-center/programmes/${row?.pmc_type === "0" || row?.type === "0" || row?.pmc_type === 0 || row?.type === 0 ? "programme" : "shortCourse"}/open/${row.id}`}
          title={row.name}
          className="as-text-blue curser feature-name"
        >
          <span title={row.name} className="textLimit100">
            {row.name}
          </span>
        </Link>
      ),
    },
    {
      name: "Code",
      selector: "Code",
      sortField: "Code",
      sortFunction: sortingCode,
      sortable: true,
      cell: (row) => (row.Code ? row.Code : "-"),
    },
    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      cell: (row) => row.status != null ? RenderPMCStatus(row.status).html : "-",
    },
    {
      name: "Programme Type",
      selector: "Programme Type",
      sortField: "Programme Type",
      sortable: true,
      sortFunction: sortingProgrammeType,
      cell: (row) => row.qualification_type != null ? RenderProgrammeType(row.qualification_type).html : "-",
    },
    {
      name: "Type",
      selector: "type",
      sortField: "pmc_type",
      sortable: true,
      sortFunction: sortingType,
      cell: (row) => row?.pmc_type !== null && row?.pmc_type !== undefined
        ? RenderProgrammeOrCourseType(row.pmc_type).html
        : row?.type !== null && row?.type !== undefined
          ? RenderProgrammeOrCourseType(row.type).html
          : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <Link
              to={`/program-management-center/programmes/${row?.pmc_type === "0" || row?.type === "0" || row?.pmc_type === 0 || row?.type === 0 ? "programme" : "shortCourse"}/open/${row.id}`}
              className="btn btn-primary rounded-circle"
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </Link>

            <button
              title="Delete"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => {
                setAssignedArticulationOptionList((prevList) => {
                  const updatedList = prevList?.filter((item) => {
                    const itemType = item.pmc_type || item.type;
                    const rowType = row.pmc_type || row.type;

                    return !(item.id === row.id && itemType?.toString() === rowType?.toString());
                  });

                  const assignedData = updatedList?.map(({ id, type, pmc_type }) => ({
                    id,
                    pmc_type: type || pmc_type,
                  }));

                  formik.setFieldValue("articulation_assign", assignedData);

                  return updatedList;
                });
              }}
            >
              <i className="fal fa-trash-alt"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  useEffect(() => {
    const payload = {
      exportStatus: "true",
    };

    GetPagesList(payload)
      .then((res) => {
        if (res.status == 200) {
          setAllPageListData(res.data?.Data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const exportAssignPageData = (fileType, fileName) => {
    let exportData = [...assignedArticulationOptionList];
    const header = ["Name", "Status", "brand templates"];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    const payload = {
      page: assignPageTableState.page,
      perPage: assignPageTableState.perPage,
      search: assignPageSearch,
      key: assignPageTableState.sortKey,
      sort: assignPageTableState.sortOrder,
      exportStatus: true,
      viaBrand: pageBrand.arr,
      viaStatus: pageStatus.arr,
    };
    GetPagesList(payload)
      .then((res) => {
        exportData = res.data.Data;
        exportData = exportData?.map((row) => ({
          ...row,
          Name: row?.PageTitle ? row?.PageTitle : "-",
          Status: row?.status ? row.status : "-",
          "brand templates": row?.brandTemplete?.length > 0 ? row.brandTemplete.map((item) => item?.templateName).join(", ") : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, exportData });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = exportData.map((row) => {
            const obj = {};
            header.forEach((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = exportData.map((row) => {
            return [row["Name"], row["Status"], row["brand templates"]];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (!(dropDownValues?.programs)) {
    return <SkeletonLoaderBasic />;
  }

  const statusOptions = mapOptions(statusArr);

  // NQF levels use the numeric value itself as the label (no separate display text).
  const nqfOptions = NQF_LevelArr.map(item => ({
    value: item.value,
    label: item.value
  }));

  const schoolOptions = mapOptions(schoolList);

  const termPeriodOptions = mapOptions(TermPeriods);

  const activeVersionOptions = mapOptions(activeVersionList);

  const qualificationOptions = mapOptions(dropDownValues?.programs);

  const netsuiteProductOptions = netsuiteProdList;

  /*
   * Campus Building options: one option per building (not collapsed by campus),
   * sourced from getCampusBuildingsList since multiple buildings can share a campus.
   */
  const campusBuildingOptions = mapBuildingsToSelect(campusBuildingsList);

  const deliveryMethodOptions = mapOptions(dropDownValues?.study_type);

  const editorArr = [
    {
      name: "Programme Content",
      id: "one",
      component: (
        <HtmlInputEditor
          editorState={subjectContent}
          setEditorState={setSubjectContent}
          onUserChange={() => markRichContentTouched("subjectContent")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.Description}
        />
      ),
      isInvalid: formik.errors.Description && formik.touched.Description,
    },
    {
      name: "Admission Requirements",
      id: "two",
      component: (
        <AccordionStack>
          <ProgrammeField>
            <SelectDropdown
              label="Minimum Admission Requirement"
              placeholder="Select Minimum Admission Requirement"
              name="min_admission_level"
              id="min_admission_level"
              options={minAdmissionLevelOptions}
              value={formik.values.min_admission_level}
              onChange={(event) => formik.setFieldValue("min_admission_level", event.target.value)}
              onBlur={formik.handleBlur}
              error={!!formik.errors.min_admission_level && !!formik.touched.min_admission_level}
              errorText={formik.errors.min_admission_level && formik.touched.min_admission_level ? formik.errors.min_admission_level : ""}
            />
          </ProgrammeField>
          <HtmlInputEditor
            editorState={admissionReq}
            setEditorState={setAdmissionReq}
            onUserChange={() => markRichContentTouched("admissionReq")}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.admission_req}
          />
        </AccordionStack>
      ),
      isInvalid: formik.errors.admission_req && formik.touched.admission_req,
    },
    {
      name: "Accreditation",
      id: "three",
      component: (
        <HtmlInputEditor
          editorState={accreditation}
          setEditorState={setAccreditation}
          onUserChange={() => markRichContentTouched("accreditation")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.accreditation}
        />
      ),
      isInvalid: formik.errors.accreditation && formik.touched.accreditation,
    },
    {
      name: "Articulation Options",
      id: "four",
      component: (
        <>
          <div className="mb-3 pmc-programmes-table">
            <DataTableComponentFrontPagination
              isInsidePopUp
              data={dataToRenderArticulationAssign()}
              columns={ArticulationAssigncolumns}
              exportData={exportDataAssignedArticulationOption}
              search={assignedArticulationSearch}
              setSearch={setAssignedArticulationSearch}
              exportFileName="Assigned_Students"
              tableButton={[
                <Button
                  key="assign-articulation-option"
                  variant="primary"
                  type="button"
                  iconLeft={<i className="fal fa-plus" />}
                  data-toggle="modal"
                  data-target="#assignArticulationPopup"
                  title="Assign Articulation Option"
                >
                  Assign Articulation Option
                </Button>,
              ]}
              filters={[
                {
                  filterName: " Status",
                  optionArr: assignedArticulationOptionFilterData.AssignStatus,
                  state: assignedStatus,
                  setState: setAssignedStatus,
                  renderLabelFunction: RenderPMCStatus,
                  uniqueId: "assignedStatus"
                },
                {
                  filterName: " Programme Type",
                  optionArr: assignedArticulationOptionFilterData.AssignProgrammeType,
                  state: assignedProgType,
                  setState: setAssignedProgType,
                  uniqueId: "assignProgrammeType",
                  renderLabelFunction: RenderProgrammeType,
                },
                {
                  filterName: " Type",
                  optionArr: assignedArticulationOptionFilterData.AssignType,
                  state: assignedType,
                  setState: setAssignedType,
                  uniqueId: "assignType",
                  renderLabelFunction: RenderProgrammeOrCourseType,
                },
              ]}
            />
          </div>
          <label htmlFor="art_additional_info">Additional Information</label>
          <HtmlInputEditor
            editorState={articulationOption}
            setEditorState={setArticulationOption}
            onUserChange={() => markRichContentTouched("articulationOption")}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.articultion_option}
          />
        </>
      ),
      isInvalid: formik.errors.articultion_option && formik.touched.articultion_option,
    },
    {
      name: "Career Opportunities",
      id: "five",
      component: (
        <AccordionStack>
          <CareerPicker pmcId={type === "open" ? id : null} pmcType="programme" />
          <HtmlInputEditor
            editorState={careerOpportunity}
            setEditorState={setCareerOpportunity}
            onUserChange={() => markRichContentTouched("careerOpportunity")}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.career_opportunities}
          />
        </AccordionStack>
      ),
      isInvalid: false,
    },
    {
      name: "Stationery List",
      id: "six",
      component: (
        <HtmlInputEditor
          editorState={studyKit}
          setEditorState={setStudyKit}
          onUserChange={() => markRichContentTouched("studyKit")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.study_kit}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Hardware/Device Requirements",
      id: "seven",
      component: (
        <>
          <div className="row">
            <div className="col-auto">
              <div className="form-group-blk mb-3">
                <label htmlFor="early_bird_discount">Laptop Options</label>
                <CheckboxRow>
                  <Checkbox
                    id="core_spec"
                    name="core_spec"
                    label="Core Spec"
                    checked={formik.values.core_spec == 1}
                    onChange={() =>
                      formik.setFieldValue("core_spec", formik.values.core_spec == 1 ? 0 : 1)
                    }
                  />
                  <Checkbox
                    id="med_spec"
                    name="med_spec"
                    label="Medium Spec"
                    checked={formik.values.med_spec == 1}
                    onChange={() =>
                      formik.setFieldValue("med_spec", formik.values.med_spec == 1 ? 0 : 1)
                    }
                  />
                  <Checkbox
                    id="high_spec"
                    name="high_spec"
                    label="High Spec"
                    checked={formik.values.high_spec == 1}
                    onChange={() =>
                      formik.setFieldValue("high_spec", formik.values.high_spec == 1 ? 0 : 1)
                    }
                  />
                </CheckboxRow>
              </div>
            </div>
          </div>
          <HtmlInputEditor
            editorState={hardwareReq}
            setEditorState={setHardwareReq}
            onUserChange={() => markRichContentTouched("hardwareReq")}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.hardware_requirement}
          />
        </>
      ),
      isInvalid: false,
    },
    {
      name: "Pricing",
      id: "eight",
      component: (
        <AccordionStack>
          <ProgrammeInformationGrid>
            <ProgrammeField>
              <TextInput
                label="Full Time, Hybrid Fee"
                required={formik.values.Delivery_Methods.includes("full")}
                prefix="R"
                type="number"
                placeholder="Enter Full Time, Hybrid Fee"
                name="full_time_hybrid_fee"
                id="full_time_hybrid_fee"
                value={formik.values.full_time_hybrid_fee}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.full_time_hybrid_fee && !!formik.touched.full_time_hybrid_fee}
                errorText={formik.errors.full_time_hybrid_fee && formik.touched.full_time_hybrid_fee ? formik.errors.full_time_hybrid_fee : ""}
              />
            </ProgrammeField>

            <ProgrammeField>
              <TextInput
                label="Full Time, Online Fee"
                required={formik.values.Delivery_Methods.includes("fulltimeonline")}
                prefix="R"
                type="number"
                placeholder="Enter Full Time, Online Fee"
                name="full_time_online_fee"
                id="full_time_online_fee"
                value={formik.values.full_time_online_fee}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.full_time_online_fee && !!formik.touched.full_time_online_fee}
                errorText={formik.errors.full_time_online_fee && formik.touched.full_time_online_fee ? formik.errors.full_time_online_fee : ""}
              />
            </ProgrammeField>

            <ProgrammeField>
              <TextInput
                label="Part Time, Online Fee"
                required={formik.values.Delivery_Methods.includes("parttimeonline")}
                prefix="R"
                type="number"
                placeholder="Enter Part Time, Online Fee"
                name="part_time_online_fee"
                id="part_time_online_fee"
                value={formik.values.part_time_online_fee}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.part_time_online_fee && !!formik.touched.part_time_online_fee}
                errorText={formik.errors.part_time_online_fee && formik.touched.part_time_online_fee ? formik.errors.part_time_online_fee : ""}
              />
            </ProgrammeField>

            <ProgrammeField>
              <TextInput
                label="Minimum Deposit"
                prefix="R"
                type="number"
                placeholder="Enter Minimum Deposit"
                name="registration_fee"
                id="registration_fee"
                value={formik.values.registration_fee}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.registration_fee && !!formik.touched.registration_fee}
                errorText={formik.errors.registration_fee && formik.touched.registration_fee ? formik.errors.registration_fee : ""}
              />
            </ProgrammeField>

            <ProgrammeField>
              <TextInput
                label="Cost Terms"
                placeholder="Enter Cost Terms"
                name="cost_terms"
                id="cost_terms"
                value={formik.values.cost_terms}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.cost_terms && !!formik.touched.cost_terms}
                errorText={formik.errors.cost_terms && formik.touched.cost_terms ? formik.errors.cost_terms : ""}
              />
            </ProgrammeField>
          </ProgrammeInformationGrid>

          <div>
            <label htmlFor="installments">Instalments</label>
            <CheckboxRow>
              {["2M", "3M", "6M", "10M", "12M", "18M", "24M"].map((option) => (
                <Checkbox
                  key={option}
                  id={option}
                  name={option}
                  label={option}
                  checked={formik.values.installments.split(",").includes(option)}
                  onChange={() => handleChangeInstallments(option)}
                />
              ))}
            </CheckboxRow>
          </div>

          <div>
            <label htmlFor="early_bird_discount">Early Bird Discount</label>
            <CheckboxRow>
              <Checkbox
                id="5_percent"
                name="5_percent"
                label="5%"
                checked={formik.values.earlyBirds == 1}
                onChange={() =>
                  formik.setFieldValue("earlyBirds", formik.values.earlyBirds == 1 ? "2" : "1")
                }
              />
              <Checkbox
                id="10_percent"
                name="10_percent"
                label="10%"
                checked={formik.values.earlyBirds == 0}
                onChange={() =>
                  formik.setFieldValue("earlyBirds", formik.values.earlyBirds == 0 ? "2" : "0")
                }
              />
            </CheckboxRow>
          </div>
        </AccordionStack>
      ),
      isInvalid: false,
    },
    {
      name: "Duration",
      id: "nine",
      component: (
        <HtmlInputEditor
          editorState={duration}
          setEditorState={setDuration}
          onUserChange={() => markRichContentTouched("duration")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.duration_dec}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Regulatory Information",
      id: "ten",
      component: (
        <HtmlInputEditor
          editorState={regulatoryInfo}
          setEditorState={setRegulatoryInfo}
          onUserChange={() => markRichContentTouched("regulatoryInfo")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.regulatory_inform}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Important Notes",
      id: "eleven",
      component: (
        <HtmlInputEditor
          editorState={impNotes}
          setEditorState={setImpNotes}
          onUserChange={() => markRichContentTouched("impNotes")}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.important_notes}
        />
      ),
      isInvalid: false,
    },
  ];

  /*
   * No third argument here on purpose: `resolveVersionSummaryState` can resolve either the
   * truly-persisted active version, or (given a `selectedVersionId`) an arbitrary other
   * version's own state. The summary strip must always describe the persisted active
   * version - never the Active Version dropdown's unsaved, in-progress selection - so this
   * always resolves against `detail.version_id`, before, during, and after any edit.
   */
  const { versionName, isActive, isLocked, activeVersion, coordinator: summaryCoordinator } =
    resolveVersionSummaryState(detail, versionList);

  const hasBrokenActiveVersion = !versionListLoading && !activeVersion && versionList.length > 0;

  const hasActiveVersion = Boolean(activeVersion);
  const versionsEnabled = Number(detail?.EnableStudypathLinkReReg) === 1;
  const canManageVersion = hasActiveVersion && versionsEnabled;
  const canCreateVersion = !hasActiveVersion && versionsEnabled;

  const openVersionDetails = () => {
    if (!canManageVersion) {
      return;
    }
    history.push(
      `/program-management-center/programmes/versions/details?versionId=${activeVersion.id}&programmeId=${id}`
    );
  };

  const createVersion = () => {
    if (!canCreateVersion) {
      return;
    }
    history.push(
      `/program-management-center/programmes/versions/create?programmeId=${id}`
    );
  };

  const versionUnavailableReason = !hasActiveVersion
    ? "No active version"
    : !versionsEnabled
      ? "Enable Modular Re-Registration to manage versions"
      : undefined;

  const createVersionDisabledReason = !versionsEnabled
    ? "Enable Modular Re-Registration to manage versions"
    : undefined;

  return (
    <>
      <ProgrammeContentWrapper>
        <ProgrammeSummaryStrip
          isResolving={versionListLoading}
          hasVersion={hasActiveVersion}
          noVersionMessage={hasBrokenActiveVersion ? "Active version unavailable" : "Create a Version"}
          onCreateVersion={hasBrokenActiveVersion ? undefined : createVersion}
          createVersionDisabled={!versionsEnabled}
          createVersionDisabledReason={createVersionDisabledReason}
          versionName={versionName}
          isActive={isActive}
          isLocked={isLocked}
          coordinator={summaryCoordinator ? {
            name: summaryCoordinator.name,
            avatar: summaryCoordinator.avatar,
            initials: summaryCoordinator.initials
          } : null}
          onAssign={openVersionDetails}
          assignDisabled={!canManageVersion}
          assignDisabledReason={versionUnavailableReason}
          totals={summaryTotals}
          isLoading={summaryTotalsLoading}
          isCoordinatorLoading={versionListLoading}
          onOpen={openVersionDetails}
          openDisabled={!canManageVersion}
          openDisabledReason={versionUnavailableReason}
        />

        <PageSections>
          <ProgrammeSection>
            <ProgrammeSectionHeader>
              <ProgrammeSectionTitle>
                Programme Information {loading ? <SectionLoadingIcon className="fas fa-cog fa-spin" /> : ""}
              </ProgrammeSectionTitle>
            </ProgrammeSectionHeader>
            <ProgrammeSectionBody>
              <form onSubmit={formik.handleSubmit}>
                <ProgrammeInformationGrid>
                  <ProgrammeField>
                    <TextInput
                      label="Name"
                      required={true}
                      placeholder="Type here"
                      name="name"
                      id="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.name && !!formik.touched.name}
                      errorText={formik.errors.name && formik.touched.name ? formik.errors.name : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <SelectDropdown
                      label="Review Status"
                      required={true}
                      placeholder="Select Review Status"
                      name="status"
                      id="status"
                      options={statusOptions}
                      value={formik.values.status}
                      onChange={(event) => formik.setFieldValue("status", event.target.value)}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.status && !!formik.touched.status}
                      errorText={formik.errors.status && formik.touched.status ? formik.errors.status : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    {id && formik.values.EnableStudypathLinkReReg && (
                      <SelectDropdown
                        label="Active Version"
                        required={activeVersionList?.length > 0}
                        placeholder="Select Active Version"
                        name="version_id"
                        id="version_id"
                        options={activeVersionOptions}
                        value={formik.values.version_id}
                        onChange={(event) => formik.setFieldValue("version_id", event.target.value)}
                        onBlur={formik.handleBlur}
                        error={!!formik.errors.version_id && !!formik.touched.version_id}
                        errorText={formik.errors.version_id && formik.touched.version_id ? formik.errors.version_id : ""}
                      />
                    )}
                  </ProgrammeField>

                  <ProgrammeField>
                    <SelectDropdown
                      label="Qualification Type"
                      required={true}
                      placeholder="Select Qualification Type"
                      name="qualification_type"
                      id="qualification_type"
                      options={qualificationOptions}
                      value={formik.values.qualification_type}
                      onChange={(event) => formik.setFieldValue("qualification_type", event.target.value)}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.qualification_type && !!formik.touched.qualification_type}
                      errorText={formik.errors.qualification_type && formik.touched.qualification_type ? formik.errors.qualification_type : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="SAQA Registered Name"
                      required={true}
                      placeholder="Type here"
                      name="SAQA_Name"
                      id="SAQA_Name"
                      value={formik.values.SAQA_Name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.SAQA_Name && !!formik.touched.SAQA_Name}
                      errorText={formik.errors.SAQA_Name && formik.touched.SAQA_Name ? formik.errors.SAQA_Name : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="SAQA ID"
                      placeholder="Type here"
                      name="saqa_id"
                      id="saqa_id"
                      value={formik.values.saqa_id}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.saqa_id && !!formik.touched.saqa_id}
                      errorText={formik.errors.saqa_id && formik.touched.saqa_id ? formik.errors.saqa_id : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="SAQA Link"
                      placeholder="Type here"
                      name="SAQA_Link"
                      id="SAQA_Link"
                      value={formik.values.SAQA_Link}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.SAQA_Link && !!formik.touched.SAQA_Link}
                      errorText={formik.errors.SAQA_Link && formik.touched.SAQA_Link ? formik.errors.SAQA_Link : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <SelectDropdown
                      label="NQF Level"
                      required={true}
                      placeholder="Select NQF Level"
                      name="NQF_Level"
                      id="NQF_Level"
                      options={nqfOptions}
                      value={formik.values.NQF_Level}
                      onChange={(event) => formik.setFieldValue("NQF_Level", event.target.value)}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.NQF_Level && !!formik.touched.NQF_Level}
                      errorText={formik.errors.NQF_Level && formik.touched.NQF_Level ? formik.errors.NQF_Level : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="Credits"
                      placeholder="Type here"
                      name="Credits"
                      id="Credits"
                      value={formik.values.Credits}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.Credits && !!formik.touched.Credits}
                      errorText={formik.errors.Credits && formik.touched.Credits ? formik.errors.Credits : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="Code"
                      placeholder="Type here"
                      name="Code"
                      id="Code"
                      value={formik.values.Code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.Code && !!formik.touched.Code}
                      errorText={formik.errors.Code && formik.touched.Code ? formik.errors.Code : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <SelectDropdown
                      label="Term Periods"
                      placeholder="Select Term Period"
                      name="Term_Period"
                      id="Term_Period"
                      options={termPeriodOptions}
                      value={formik.values.Term_Period}
                      onChange={(event) => formik.setFieldValue("Term_Period", event.target.value)}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.Term_Period && !!formik.touched.Term_Period}
                      errorText={formik.errors.Term_Period && formik.touched.Term_Period ? formik.errors.Term_Period : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <TextInput
                      label="Duration (Weeks)"
                      placeholder="Type here"
                      name="Duration"
                      id="Duration"
                      value={formik.values.Duration}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.Duration && !!formik.touched.Duration}
                      errorText={formik.errors.Duration && formik.touched.Duration ? formik.errors.Duration : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <SelectDropdown
                      label="School"
                      required={true}
                      placeholder="Select School"
                      name="School"
                      id="School"
                      options={schoolOptions}
                      value={formik.values.School}
                      onChange={(event) => formik.setFieldValue("School", event.target.value)}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.School && !!formik.touched.School}
                      errorText={formik.errors.School && formik.touched.School ? formik.errors.School : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <MultiSelectDropdown
                      label="Campuses"
                      required={true}
                      placeholder="Select Campuses"
                      name="campusBuildings"
                      id="campusBuildings"
                      options={campusBuildingOptions}
                      value={(formik.values.campusBuildings || []).map((building) =>
                        building && typeof building === "object" ? building.value : building
                      )}
                      onChange={(event) => {
                        const rawValues = event?.target?.value || [];
                        const selectedBuildings = campusBuildingOptions.filter((option) =>
                          rawValues.includes(option.value)
                        );
                        formik.setFieldValue("campusBuildings", selectedBuildings);
                      }}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.campusBuildings && !!formik.touched.campusBuildings}
                      errorText={formik.errors.campusBuildings && !!formik.touched.campusBuildings ? formik.errors.campusBuildings : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField>
                    <MultiSelectDropdown
                      label="Learning Methods"
                      required={true}
                      placeholder="Select Learning Methods"
                      name="Delivery_Methods"
                      id="Delivery_Methods"
                      options={deliveryMethodOptions}
                      value={formik.values.Delivery_Methods || []}
                      onChange={(event) => {
                        formik.setFieldValue("Delivery_Methods", event?.target?.value || []);
                      }}
                      onBlur={formik.handleBlur}
                      error={!!formik.errors.Delivery_Methods && !!formik.touched.Delivery_Methods}
                      errorText={formik.errors.Delivery_Methods && !!formik.touched.Delivery_Methods ? formik.errors.Delivery_Methods : ""}
                    />
                  </ProgrammeField>

                  <ProgrammeField></ProgrammeField>
                </ProgrammeInformationGrid>
              </form>
            </ProgrammeSectionBody>
          </ProgrammeSection>

          <ProgrammeSection>
            <ProgrammeSectionHeader>
              <ProgrammeSectionTitle>Integration Settings</ProgrammeSectionTitle>
            </ProgrammeSectionHeader>
            <ProgrammeSectionBody>
              <IntegrationStack>

                <SelectDropdown
                  label="NetSuite Product"
                  placeholder="Select NetSuite Product"
                  name="netsuite_product"
                  id="netsuite_product"
                  options={netsuiteProductOptions}
                  value={formik.values.netsuite_product}
                  onChange={(event) => formik.setFieldValue("netsuite_product", event.target.value)}
                  onBlur={formik.handleBlur}
                  error={!!formik.errors.netsuite_product && !!formik.touched.netsuite_product}
                  errorText={formik.errors.netsuite_product && !!formik.touched.netsuite_product ? formik.errors.netsuite_product : ""}
                />

                <PermissionsGate
                  scopes={["pmcpedit"]}
                  errorProps={{ disabled: true, disabledReason: "Insufficient Permissions" }}
                >
                  <ToggleSwitch
                    label="Activate NetSuite Integration"
                    description="This activates the NetSuite integration, when new opportunities are created modules will be automatically assigned to the opportunity as per the first phase of the study path of the active version."
                    name="EnableStudypathLink"
                    id="EnableStudypathLink"
                    checked={formik.values.EnableStudypathLink === true}
                    onChange={(event) => formik.setFieldValue("EnableStudypathLink", event.target.checked)}
                  />
                </PermissionsGate>

                <PermissionsGate
                  scopes={["pmcpedit"]}
                  errorProps={{ disabled: true, disabledReason: "Insufficient Permissions" }}
                >
                  <ToggleSwitch
                    label="Activate Modular Re-Registration"
                    description="Enables AMI integration for modular re-registration, gradebook, grade management, and QA in PMC."
                    name="EnableStudypathLinkReReg"
                    id="EnableStudypathLinkReReg"
                    checked={formik.values.EnableStudypathLinkReReg === true}
                    onChange={(event) => formik.setFieldValue("EnableStudypathLinkReReg", event.target.checked)}
                  />
                </PermissionsGate>

                {formik.values.EnableStudypathLinkReReg === true && (
                  <>
                    <ReRegistrationGrid>
                    <ReRegistrationFrequencyField>
                      <SelectDropdown
                        size="lg"
                        label="Re-Reg Frequency"
                        placeholder="Select Re-Reg Frequency"
                        name="reRegFrequency"
                        id="reRegFrequency"
                        options={reRegFrequencyOptions}
                        value={formik.values.reRegFrequency}
                        onChange={(event) =>
                          formik.setFieldValue("reRegFrequency", event.target.value)
                        }
                        onBlur={formik.handleBlur}
                        error={
                          !!formik.errors.reRegFrequency &&
                          !!formik.touched.reRegFrequency
                        }
                        errorText={
                          formik.errors.reRegFrequency &&
                          formik.touched.reRegFrequency
                            ? formik.errors.reRegFrequency
                            : ""
                        }
                      />
                    </ReRegistrationFrequencyField>

                    <ReRegistrationCountField>
                        <TextInput
                          size="lg"
                          label="Full Time, Minimum Module Count"
                          type="number"
                          placeholder="Type here"
                          name="FTMin"
                          id="FTMin"
                          value={formik.values.FTMin}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={!!formik.errors.FTMin && !!formik.touched.FTMin}
                          errorText={
                            formik.errors.FTMin && formik.touched.FTMin
                              ? formik.errors.FTMin
                              : ""
                          }
                        />
                      </ReRegistrationCountField>

                      <ReRegistrationCountField>
                        <TextInput
                          size="lg"
                          label="Full Time, Maximum Module Count"
                          type="number"
                          placeholder="Type here"
                          name="FTMax"
                          id="FTMax"
                          value={formik.values.FTMax}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={!!formik.errors.FTMax && !!formik.touched.FTMax}
                          errorText={
                            formik.errors.FTMax && formik.touched.FTMax
                              ? formik.errors.FTMax
                              : ""
                          }
                        />
                      </ReRegistrationCountField>

                      <ReRegistrationCountField>
                        <TextInput
                          size="lg"
                          label="Part Time, Minimum Module Count"
                          type="number"
                          placeholder="Type here"
                          name="PTMin"
                          id="PTMin"
                          value={formik.values.PTMin}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={!!formik.errors.PTMin && !!formik.touched.PTMin}
                          errorText={
                            formik.errors.PTMin && !!formik.touched.PTMin
                              ? formik.errors.PTMin
                              : ""
                          }
                        />
                      </ReRegistrationCountField>

                      <ReRegistrationCountField>
                        <TextInput
                          size="lg"
                          label="Part Time, Maximum Module Count"
                          type="number"
                          placeholder="Type here"
                          name="PTMax"
                          id="PTMax"
                          value={formik.values.PTMax}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={!!formik.errors.PTMax && !!formik.touched.PTMax}
                          errorText={
                            formik.errors.PTMax && !!formik.touched.PTMax
                              ? formik.errors.PTMax
                              : ""
                          }
                        />
                      </ReRegistrationCountField>
                    </ReRegistrationGrid>

                    <PermissionsGate
                      scopes={["pmcpedit"]}
                      errorProps={{ disabled: true, disabledReason: "Insufficient Permissions" }}
                    >
                      <ToggleSwitch
                        label="Articulation Mandatory"
                        description="Indicates articulation is mandatory, which will activate re-reg nurturing for graduates as well"
                        name="articulationMandatory"
                        id="articulationMandatory"
                        checked={formik.values.articulationMandatory === true}
                        onChange={(event) => formik.setFieldValue('articulationMandatory', event.target.checked)}
                      />
                    </PermissionsGate>
                  </>
                )}
              </IntegrationStack>

              {formik.values.override_default_tc ? (
                <div className="row mb-3">
                  <div className="col-md-6 col-lg-3">
                    <div className="d-flex align-items-start flex-column">
                      <label>
                        Assigned Terms & Conditions Page{" "}
                        {formik.values.override_default_tc && "*"}{" "}
                        <i className="fal fa-info-circle grade-icon"></i>
                      </label>
                      <button
                        className={
                          "btn btn-save btn-success" +
                          (formik.errors.terms_conditions_page && formik.touched.terms_conditions_page ? " file-req is-invalid" : "")
                        }
                        type="button"
                        title="Assign Page"
                        data-toggle="modal"
                        data-target="#assignPagePopup"
                      >
                        <i className="fal fa-plus"></i> Assign Page
                      </button>
                      {formik.values.terms_conditions_page
                        ? allpageListData?.filter((page) => page.PageID === formik.values.terms_conditions_page).map((assignedPage) => (
                          <div className="frm-group w-100" key={assignedPage.PageID}>
                            <ul className="list-unstyled attached-file-ul m-0">
                              <li>
                                <a target="_blank" href={`/website_management/pages/staticpages/table/update/${assignedPage.PageID}`}>
                                  <span className="textLimit100 as-text-blue w-100" title={assignedPage.PageTitle}>
                                    {TrimText(assignedPage.PageTitle, 30)}
                                  </span>
                                </a>
                                <button
                                  className="btn btn-danger rounded-circle btn-dropdown-item"
                                  title="Delete"
                                  onClick={() => {
                                    formik.setFieldValue("terms_conditions_page", "");
                                  }}
                                >
                                  <i className="fal fa-trash-alt"></i>
                                </button>
                              </li>
                            </ul>
                          </div>
                        ))
                        : null}
                    </div>
                  </div>
                </div>
              ) : null}
            </ProgrammeSectionBody>
          </ProgrammeSection>

          <AccordionWrapper>
            {editorArr.map((item, index) => (
              <AccordionSection key={index}>
                <AccordionCard>
                  <AccordionCardHeader
                    id={`heading${item.id}`}
                    onClick={() => setOpenAccordionId(item.id)}
                  >
                    <AccordionTitle>{item.name}</AccordionTitle>
                  </AccordionCardHeader>

                  <AccordionContent
                    id={`collapse${item.id}`}
                    className={`collapse${openAccordionId === item.id ? " show" : ""}`}
                    aria-labelledby={`heading${item.id}`}
                  >
                    <AccordionBody>
                      {(editorToShow || type === "add") && item.component}
                    </AccordionBody>
                  </AccordionContent>
                </AccordionCard>

                <AccordionButton
                  type="button"
                  onClick={() =>
                    setOpenAccordionId(openAccordionId === item.id ? null : item.id)
                  }
                  aria-expanded={openAccordionId === item.id}
                  aria-controls={`collapse${item.id}`}
                >
                  <AccordionChevronIcon className="fal fa-chevron-down rotate-icon" />
                </AccordionButton>
              </AccordionSection>
            ))}
          </AccordionWrapper>
        </PageSections>
      </ProgrammeContentWrapper>

      <StickyFooter
        onSave={formik.handleSubmit}
        onCancel={handlereset}
        isLoading={disabled}
      >
        {hasUnsavedChanges && (
          <UnsavedChangesText>
            <i
              className="fas fa-exclamation-circle"
              aria-hidden="true"
            />
            You have unsaved changes
          </UnsavedChangesText>
        )}
      </StickyFooter>

      {showCancelConfirmation && (
        <Modal
          title="Discard Changes"
          description="Cancel your changes and restore the last saved programme details?"
          onClose={() => setShowCancelConfirmation(false)}
          primaryAction={{
            label: "Keep Editing",
            icon: "arrow-left",
            tone: "secondary",
            onClick: () => setShowCancelConfirmation(false),
          }}
          secondaryAction={{
            label: "Discard Changes",
            icon: "trash",
            tone: "destructive",
            onClick: restoreSavedValues,
          }}
        />
      )}

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignPagePopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-plus"></i> Assign Page
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <DataTableComponent
                data={assignPageList}
                loading={assignPageLoading}
                state={assignPageTableState}
                setState={setAssignPageTableState}
                setSearch={setAssignPageSearch}
                totalRows={assignPageTotalRows}
                columns={assignPageColumn}
                exportFunction={exportAssignPageData}
                exportFileName={"Assign_Page"}
                isInsidePopUp={true}
                filters={[
                  {
                    filterName: "Status",
                    optionArr: PageFilterData.status,
                    state: pageStatus,
                    setState: setPageStatus,
                    renderLabelFunction: RenderPMCPageStatus,
                  },
                  {
                    filterName: "Brand Templates",
                    optionArr: PageFilterData.BrandList,
                    state: pageBrand,
                    isOptionReversed: false,
                    stopOptionSorting: true,
                    setState: setPageBrand,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignArticulationPopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-plus"></i> Assign Articulation Options
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <DataTableComponent
                data={articulationOptionList}
                columns={articulationOptionColumn}
                loading={articulationOptionLoading}
                search={articulationOptionSearch}
                setSearch={setArticulationOptionSearch}
                state={articulationOptionTableState}
                setState={setArticulationOptionTableState}
                totalRows={articulationOptionTotalRow || 0}
                exportFunction={exportDataArticulationOption}
                exportFileName={"Articulation_Option"}
                isInsidePopUp={true}
                keyField="ref_id"
                filters={[
                  {
                    filterName: "Status",
                    optionArr: articulationOptionFilterData.status,
                    state: artStatus,
                    setState: setArtStatus,
                    renderLabelFunction: RenderPMCStatus,
                  },
                  {
                    filterName: "Programme Type",
                    optionArr: articulationOptionFilterData.programmeType,
                    state: artProgType,
                    setState: setArtProgType,
                    renderLabelFunction: RenderProgrammeType,
                  },
                  {
                    filterName: "Type",
                    optionArr: articulationOptionFilterData.type,
                    state: artType,
                    setState: setArtType,
                    renderLabelFunction: RenderProgrammeOrCourseType,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProgramDetail;